import React, { useState, useMemo } from "react";
import "../UIcss/Entity.css";
import { FaHashtag, FaFont, FaCheck } from "react-icons/fa";
import { LuCopy, LuInfo } from "react-icons/lu";
import { entityData } from "./entityData.js";
import Pagination from "./Pagination.jsx";

// --- RENDERER COMPONENT ---

const EntityRenderer = ({ item, onCopy }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    onCopy(item.char);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="entity-card">
      <div className="entity-meta-header">
        <span className="entity-label">{item.name}</span>
        <button
          className="entity-copy-btn"
          onClick={handleCopy}
          title="Copy Character"
        >
          {copied ? <FaCheck size={12} /> : <LuCopy />}
        </button>
      </div>

      <div className="entity-preview-area" onClick={handleCopy}>
        <div className="entity-char-display">{item.char}</div>
      </div>

      <div className="entity-details-footer">
        <div className="entity-desc-text">{item.desc}</div>
      </div>
    </div>
  );
};

const Entity = () => {
  const [activeCategory, setActiveCategory] = useState("All");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 40;

  const categories = useMemo(
    () => ["All", ...new Set(entityData.map((item) => item.category))],
    [],
  );

  const filteredData = useMemo(
    () =>
      activeCategory === "All"
        ? entityData
        : entityData.filter((item) => item.category === activeCategory),
    [activeCategory],
  );

  const currentItems = useMemo(() => {
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    return filteredData.slice(indexOfFirstItem, indexOfLastItem);
  }, [currentPage, filteredData]);

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
  };

  const handlePageChange = (page) => setCurrentPage(page);

  return (
    <div className="entity-page-wrapper">
      <div className="library-header">
        <div className="header-content">
          <h1>
            <FaFont /> Entities <span>Library</span>
          </h1>
          <div className="category-filter-wrap">
            {categories.map((cat) => (
              <button
                key={cat}
                onClick={() => {
                  setActiveCategory(cat);
                  setCurrentPage(1);
                }}
                className={`category-pill ${activeCategory === cat ? "active" : ""}`}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="entity-grid">
        {currentItems.map((item, index) => (
          <EntityRenderer
            key={`${item.char}-${index}`}
            item={item}
            onCopy={handleCopy}
          />
        ))}
      </div>

      <Pagination
        currentPage={currentPage}
        totalPages={Math.ceil(filteredData.length / itemsPerPage)}
        onPageChange={handlePageChange}
        totalItems={filteredData.length}
        itemsPerPage={itemsPerPage}
      />
    </div>
  );
};

export default Entity;
